import script from "./InvestigationReport.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationReport.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationReport.vue?vue&type=style&index=0&id=37e1aae1&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37e1aae1"]])

export default __exports__